<template>
	<div class="joinbox">
		<img :src="detail.image" class="joinbanner"/>
		<a class="joinbtn" :href="detail.url" target="_blank">招聘入口</a>
	</div>
</template>

<script>
export default {
    name: 'joinus',
    data () {
        return {
            msg: 'Welcome to Your joinus',
            detail:[]
        }
    },
    mounted() {
        this.getJoinUs();
    },
    methods:{

        // 加载公司简介
        getJoinUs: async function () {
            const res = await this.$getJSON('/index/joinUs');
            this.detail = res.data.detail;
        }
    }
}
</script>

<style scoped>
	.bannerimgbox img{
	width: 100%;
	display: block;
}
	.joinbox{
		text-align: center;
		margin-top: 20px;
		height: fit-content;
		position: relative;
		height: fit-content;
	}
	.joinbanner{
		padding: 0px;
		display: block;
		margin: 0px;
		width: 100%;
		height: auto;
	}
	.joinbtn{
	    position: absolute;
	    bottom: 144px;
	    left: 44%;
	    width: 246px;
	    height: 62px;
	    line-height: 62px;
	    font-size: 30px;
		font-weight: bolder;
		cursor: pointer;
		background-color: #fff;
		color: #000000;
		letter-spacing: 3px;
		border-radius: 40px;
		}
</style>


// WEBPACK FOOTER //
// src/vew/joinUs.vue